import { Global_var } from "../global/global_var";
import { LoginService } from "./login.service";
import RestDataSource from "./restdatasource";

export const VideoService = {
  videoReportList,
  saveVideo,
  getSubCategoriesOnSelectedCategory,
  getVideoDetailsById,
  updateVideoDetails,
  fetchAllCategoryByLevel
};
function fetchAllCategoryByLevel(param, data, fn, fnError) {
  var url = `${Global_var.BASEURL}${Global_var.URL_GET_ALL_CATEGORIES}?${param}`;
  return new RestDataSource(url, fnError).Store(data, (res) => {

    if (res != null) {
      if (res.headers["jtitoken"] != null) {
        localStorage.setItem('jti-token', res.headers.jtitoken);
      }
      fn(res.data);
    }
  });
}

function getSubCategoriesOnSelectedCategory(
  param,
  data,
  id,
  getSubCategoriesOnSelectedCategory,
  fn,
  fnError
) {
  LoginService.TokenUser((res) => {
    if (res.status === "success") {
      localStorage.setItem("jwt-token", res.responseObject);
      var url =
       `${Global_var.BASEURL }+
       ${Global_var.URL_GET_SUB_CATEGORIES_ON_SELECTED_CATEGORIES}?${param}`;
       console.log("service video",url,data,id);
      return new RestDataSource(url, fnError).Store(
        getSubCategoriesOnSelectedCategory,data,
        (res) => {
          if (res != null) {
            if (res.headers["jtitoken"] != null) {
              localStorage.setItem("jti-token", res.headers.jtitoken);
            }
            fn(res.data);
          }
        }
      );
    }
  }, fnError);
}

function saveVideo(data, fn, fnError) {
  LoginService.TokenUser((res) => {
    if (res.status === "success") {
      localStorage.setItem("jwt-token", res.responseObject);
      let url = Global_var.BASEURL + Global_var.URL_SAVE_VIDEO;
      return new RestDataSource(url, fnError).Store(data, (res) => {
        if (res != null) {
          if (res.headers["jtitoken"] != null) {
            localStorage.setItem("jti-token", res.headers.jtitoken);
          }
          fn(res.data);
        }
      });
    }
  }, fnError);
}

function getVideoDetailsById(getVideoDetailsById, fn, fnError) {
  LoginService.TokenUser((res) => {
    if (res.status === "success") {
      localStorage.setItem("jwt-token", res.responseObject);
      var url = Global_var.BASEURL + Global_var.URL_GET_VIDEO_DETAILS_BY_ID;
      return new RestDataSource(url, fnError).GetOneByParam(
        getVideoDetailsById,
        (res) => {
          if (res != null) {
            if (res.headers["jtitoken"] != null) {
              localStorage.setItem("jti-token", res.headers.jtitoken);
            }
            fn(res.data);
          }
        }
      );
    }
  }, fnError);
}

function updateVideoDetails(data, fn, fnError) {
  LoginService.TokenUser((res) => {
    if (res.status === "success") {
      localStorage.setItem("jwt-token", res.responseObject);
      let url = Global_var.BASEURL + Global_var.URL_UPDATE_VIDEO_DETAILS;
      return new RestDataSource(url, fnError).Update(data, (res) => {
        if (res != null) {
          if (res.headers["jtitoken"] != null) {
            localStorage.setItem("jti-token", res.headers.jtitoken);
          }
          fn(res.data);
        }
      });
    }
  }, fnError);
}
function videoReportList(videoReportList, fn, fnError) {
  LoginService.TokenUser((res) => {
    if (res.status === "success") {
      localStorage.setItem("jwt-token", res.responseObject);
      var url = Global_var.BASEURL + Global_var.URL_VIDEO_REPORT_LIST;
      return new RestDataSource(url, fnError).GetOneByParam(
        videoReportList,
        (res) => {
          if (res != null) {
            if (res.headers["jtitoken"] != null) {
              localStorage.setItem("jti-token", res.headers.jtitoken);
            }
            fn(res.data);
          }
        }
      );
    }
  }, fnError);
}
